<div class="login_page CompleteProfile completRegt">
  <div class="modal-header close_btn_align" *ngIf="isShowCrossbtn">
    <button type="button" class="btn-close btn-close-black" data-bs-dismiss="modal" (click)="closeModal()"></button>
  </div>

  <div class="loader-overlay" *ngIf="isLoading">
    <div class="spinner">
      <div></div>
      <div></div>
    </div>
  </div>

  <div class="justify-content-center ng-star-inserted">
    <div class="user-show-head">{{ pageTitle }}</div>
  </div>

  <form [formGroup]="form">
    <div id="txtSearchProdAssign">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="name-user" class="lable-space">Phone Number</label>
            <app-country-picker name="phoneNumber" formControlName="phoneNumber"> </app-country-picker>
            <div *ngIf="f['phoneNumber'].touched && f['phoneNumber'].invalid" class="alert alert-danger">
              <div *ngIf="f['phoneNumber'].errors && f['phoneNumber'].errors?.['invalidPhoneNumber']" class="text-danger">
                Invalid Phone Number.
              </div>
              <div *ngIf="f['phoneNumber'].errors && f['phoneNumber'].errors?.['required']">Phone Number Required</div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label for="name-user" class="lable-space">Name</label>
            <input
              type="text"
              id="names-user"
              placeholder="Type Name Here"
              required
              class="form-control input-text"
              name="name"
              formControlName="name"
            />
            <div *ngIf="f['name'].touched && f['name'].invalid" class="alert alert-danger">
              <div *ngIf="f['name'].errors && f['name'].errors['required']">Enter Name.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="name-user" class="lable-space">Email</label>
            <input
              type="email"
              id="email-user"
              placeholder="Type Email Here"
              required
              class="form-control input-text"
              name="email"
              formControlName="email"
            />
            <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger">
              <div *ngIf="f['email'].errors && f['email'].errors['required']">Email Required</div>
              <div *ngIf="f['email'].errors && f['email'].errors['pattern']" class="text-danger">
                Please provide a valid email address
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <div *ngIf="pageType == 2" class="form-group">
              <label for="name-user" class="lable-space">Grade</label>
              <select class="form-control" name="gradeId" required formControlName="gradeId">
                <option value="" disabled selected>Select</option>
                <option *ngFor="let items of getGrade | orderBy : 'asc' : 'id'" [value]="items.id">
                  {{ items.name }}<sup>th</sup>
                </option>
              </select>
              <div *ngIf="f['gradeId'].touched && f['gradeId'].invalid" class="alert alert-danger selectGrade">
                <div *ngIf="f['gradeId'].errors && f['gradeId'].errors['required']">Select Grade</div>
              </div>
            </div>

            <div *ngIf="pageType != 2" class="form-group row justify-content-around">
              <div class="col-12 px-3">Select grade of the Student</div>

              <div class="gradeSelection">
                <div class="garde-padding" *ngFor="let items of getGrade | orderBy : 'asc' : 'id'">
                  <input
                    type="radio"
                    name="gradeId"
                    id="{{ items.id }}"
                    value="{{ items.id }}"
                    class="form-check-input form-control"
                    required
                    formControlName="gradeId"
                  />
                  <label class="radio-label" for="{{ items.name }}"> {{ items.name }}<sup>th</sup> </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-6">
      <div class="form-group">

      </div>
    </div> -->
      </div>

      <div class="text-center login_submit">
        <button type="submit" class="btn-cms-valid" (click)="validateUser()">{{ pageType == 2 ? "CONNECT" : "Submit" }}</button>
      </div>
    </div>
  </form>
</div>
